import { propsToRegisterNewProduct } from "../types/products";
import api from "./api";

export const deleteProduct = async (uid_produto: string) => {
  try {
    const res = await api.post(`/products/deleteProduct/`, { uid_produto });

    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const loadAllProdutcs = async (
  search?: string,
  page?: number,
  filterValues?: {
    titulo?: string;
    measure?: string;
    typeProduct?: string;
    category?: string;
  },
  orderTable?: {
    sku?: "ASC" | "DESC";
    codigo_de_barras?: "ASC" | "DESC";
    titulo?: "ASC" | "DESC";
    medida?: "ASC" | "DESC";
    categoria?: "ASC" | "DESC";
    preco?: "ASC" | "DESC";
  },
) => {
  try {
    const res = await api.get(`/products/loadAllProdutcs/${page}`, {
      params: { search, filterValues, orderTable },
    });

    return res.data.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const getProduct = async (
  uid_produto: string,
  identifyNextSku?: boolean,
) => {
  try {
    const res = await api.get(`/products/getProduct/`, {
      params: { uid_produto, identifyNextSku },
    });

    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const importExistingProduct = async ({
  uid_produto,
}: {
  uid_produto: string;
}) => {
  try {
    const res = await api.post("/products/importExistingProduct", {
      uid_produto,
    });
    return res.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message = "Erro ao importar produto";
    }

    throw error;
  }
};

export const loadTableNutrition = async () => {
  try {
    const res = await api.get(`/products/loadTableNutrition/`);

    return res.data.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const loadAllCategoryProduct = async () => {
  try {
    const res = await api.get(`/products/loadAllCategoryProduct/`);

    return res.data.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const loadTypeProduct = async () => {
  try {
    const res = await api.get(`/products/loadTypeProduct/`);

    return res.data.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const loadUnidadeMedida = async () => {
  try {
    const res = await api.get(`/products/loadUnidadeMedida/`);

    return res.data.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const registerOrEditProduct = async ({
  codigo_sku,
  tags,
  codigo_de_barras,
  titulo,
  uid_fabrica,
  uid_produto,
  id_informacao_nutricional,
  uid_projeto,
  uid_tipo_unidade_medida,
  tipo_produto,
  uid_produto_tipo,
  preco,
  vencimento_dias,
  estoque_minimo,
  uid_estabelecimento,
  uid_produto_categoria,
  uid_produto_ibpt,
}: propsToRegisterNewProduct) => {
  try {
    const res = await api.post("/products/registerOrEditProduct", {
      codigo_sku,
      tags,
      codigo_de_barras,
      titulo,
      uid_fabrica,
      uid_produto,
      uid_projeto,
      id_informacao_nutricional,
      uid_tipo_unidade_medida,
      tipo_produto,
      uid_produto_tipo,
      preco,
      vencimento_dias,
      estoque_minimo,
      uid_estabelecimento,
      uid_produto_categoria,
      uid_produto_ibpt,
    });
    return res.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message = "Erro ao salvar produto";
    }

    throw error;
  }
};

export const registerOrEditProductUnitConversion = async (conversionData: {
  uid_produto_unidade_conversao?: string;
  uid_produto: string;
  uid_unidade_origem: string;
  uid_unidade_destino: string;
  fator_conversao: number;
  vigencia_final?: string | null;
}) => {
  try {
    const res = await api.post(
      "/routesProductUnitConversion/registerOrEditProductUnitConversion",
      conversionData,
    );

    return res.data;
  } catch (error: any) {
    console.error(
      "Erro ao cadastrar/editar conversão de unidade:",
      error.response?.data || error,
    );
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.errors?.[0] ||
        error?.message ||
        "Erro desconhecido ao cadastrar conversão de unidade!",
    );
  }
};

export const searchExistenceBarcode = async (barcode: string) => {
  try {
    const res = await api.get(`/products/searchExistenceBarcode/${barcode}`);

    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

type existenceSKU = {
  productFound: { uid_produto: string; titulo: string };
  nextSKU: number;
  status: "FREE" | "EXISTS_IN_PROJECT" | "EXISTS_IN_ESTABLISHMENT";
};
export const searchExistenceSKU = async (
  codigo_sku: string,
  uid_produto: string | null = null,
) => {
  try {
    const res = await api.get(`/products/searchExistenceSKU`, {
      params: { codigo_sku, uid_produto },
    });
    const { productFound, nextSKU, status } = res.data.data as existenceSKU;

    return { productFound, nextSKU, status };
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const currentProductIbpt = async (uid_produto_ibpt: string) => {
  try {
    const res = await api.get("/products/currentProductIbpt", {
      params: { uid_produto_ibpt },
    });
    return res.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data ||
        error.response?.data?.message ||
        "Erro desconhecido!",
    );
  }
};

export const productIbpt = async (search: string) => {
  try {
    const res = await api.get("/products/productIbpt", { params: { search } });
    return res.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data ||
        error.response?.data?.message ||
        "Erro desconhecido!",
    );
  }
};

export const cancelTableCategoryProduct = async (
  uid_produto_categoria: string,
) => {
  try {
    const res = await api.delete(`/products/cancelTableCategoryProduct/`, {
      params: { uid_produto_categoria },
    });

    return res.data.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message = "Erro ao cancelar tabela";
    }

    throw error;
  }
};

export interface IordemCategoryProduct {
  title?: "ASC" | "DESC";
}

export const getCategoriesProducts = async (
  search: string,
  page: number,
  orderTable: IordemCategoryProduct,
) => {
  try {
    const res = await api.get(`/products/getCategoriesProducts/`, {
      params: { search, page, orderTable },
    });

    return res.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message = "Erro ao carregar categorias";
    }

    throw error;
  }
};

export const patchCategoryProduct = async (uid: string, title: string) => {
  try {
    const res = await api.patch(`/products/patchCategoryProduct/`, {
      title,
      uid,
    });

    return res.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message = "Erro ao atualizar categoria";
    }

    throw error;
  }
};

export const postCategoryProduct = async (title: string) => {
  try {
    const res = await api.post(`/products/postCategoryProduct/`, {
      title,
    });

    return res.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message = "Erro ao atualizar categoria";
    }

    throw error;
  }
};
